import React from 'react';

import clsx from 'clsx';
import { Badge, type BadgeProps } from 'react-bootstrap';

import style from './style.module.less';

export enum BadgeVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Light = 'light',
  Dark = 'dark',
  Info = 'info',
}

export interface IPohBadgeProps extends BadgeProps {
  variant?: BadgeVariant;
  rounded?: boolean;
}
const PohBadge: React.FC<IPohBadgeProps> = ({
  children,
  variant = BadgeVariant.Light,
  rounded = false,
  className,
  ...rest
}) => {
  return (
    <Badge
      {...rest}
      bg={variant}
      pill={rounded}
      text={variant === BadgeVariant.Warning || variant === BadgeVariant.Light ? 'dark' : 'light'}
      className={clsx(style.badge, className)}
    >
      {children}
    </Badge>
  );
};

export default PohBadge;
